module.exports = __webpack_public_path__ + "static/smartrmail-3aeb08b470bf5db756ccfdc64671fe02.png";